import MDAlert from "components/MDAlert";
import { UpdateProductGroupInput, ProductGroup } from "generated/graphql";
import useUpdateProductGroup from "hooks/products/useUpdateProductGroup";
import { useCallback } from "react";
import { useNavigate } from "react-router";
import parseGraphQLError from "utils/graphQL/parseGraphQLError";
import ProductGroupUpdateForm from "./Forms/ProductGroupUpdateForm";

interface ProductGroupUpdateProps {
  productGroup: ProductGroup;
}

export default function ProductGroupUpdate({ productGroup }: ProductGroupUpdateProps) {
  const navigate = useNavigate();
  const [updateProductGroup, { loading, error, isSuccess, getData }] = useUpdateProductGroup();

  const handleSubmit = useCallback(
    async (input: UpdateProductGroupInput) => {
      const result = await updateProductGroup({ variables: { input } });
      const success = isSuccess(result.data);
      if (success) {
        navigate("/product-groups");
      }
      return { success, data: getData(result) };
    },
    [updateProductGroup, isSuccess, getData, navigate]
  );

  return (
    <>
      {error && <MDAlert color="error">{parseGraphQLError(error)}</MDAlert>}
      <ProductGroupUpdateForm
        loading={loading}
        onSubmit={handleSubmit}
        productGroup={productGroup}
      />
    </>
  );
}
